var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisa = function SvgVisa(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "#172B85",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.45 15.505H8.564L7.149 9.949c-.067-.256-.21-.482-.42-.588A6 6 0 0 0 5 8.773v-.214h3.04a.8.8 0 0 1 .786.694l.734 4.008 1.885-4.702h1.835zm3.878 0h-1.781l1.467-6.946h1.782zm3.773-5.022c.052-.374.367-.588.734-.588a3.24 3.24 0 0 1 1.73.32l.314-1.495a4.4 4.4 0 0 0-1.625-.322c-1.729 0-2.987.963-2.987 2.298 0 1.016.89 1.55 1.52 1.87.68.32.943.535.89.855 0 .48-.524.695-1.047.695-.63 0-1.259-.16-1.834-.428l-.315 1.496c.63.267 1.31.374 1.94.374 1.938.053 3.143-.908 3.143-2.35 0-1.818-2.463-1.924-2.463-2.725m8.699 5.022-1.415-6.946h-1.52a.79.79 0 0 0-.733.534l-2.62 6.412h1.834l.366-1.015h2.254l.21 1.015zm-2.672-5.075.523 2.618h-1.467z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export default ForwardRef;